let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1dkiR")).then(() => parcelRequire('aOZ9H'));